interface Props {
  title: string
  hint?: string
  actionLabel?: string
  onAction?: () => void
}

export default function EmptyState({ title, hint, actionLabel, onAction }: Props) {
  return (
    <div className="empty-state">
      <h3>{title}</h3>
      {hint && <p>{hint}</p>}
      {actionLabel && onAction && (
        <button type="button" className="btn btn-primary" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  )
}